import {
  INIT_CHAT_SCREEN,
  CREATE_CHAT_HANDLER_SUCCESS,
  CREATE_CHAT_HANDLER_FAIL,
  CHANNEL_TITLE_CHANGED,
  CHANNEL_TITLE_CHANGED_FAIL,
  CHANNEL_PICTURE_CHANGED,
  CHANNEL_PICTURE_CHANGED_FAIL,
  MESSAGE_LIST_SUCCESS,
  MESSAGE_LIST_FAIL,
  SEND_MESSAGE_TEMPORARY,
  SEND_MESSAGE_SUCCESS,
  SEND_MESSAGE_FAIL,
  USER_BLOCK_SUCCESS,
  USER_BLOCK_FAIL,
  USER_UNBLOCK_SUCCESS,
  USER_UNBLOCK_FAIL,
  CLEAR_CHANNEL_SUCCESS,
  CLEAR_CHANNEL_FAIL,
  SEND_TYPING_START_SUCCESS,
  SEND_TYPING_START_FAIL,
  SEND_TYPING_END_SUCCESS,
  SEND_TYPING_END_FAIL,

  MESSAGE_RECEIVED,
  MESSAGE_UPDATED,
  MESSAGE_DELETED,
  TYPING_STATUS_UPDATED,
  READ_RECEIPT_UPDATED,
  MESSAGE_FILE_PROGRESS
} from './types'

import {
  sbGetChannelTitle,
  sbGetMessageList,
  sbSendTextMessage,
  sbSendFileMessage,
  sbUserBlock,
  sbGetGroupChannel,
  sbTypingStart,
  sbTypingEnd,
  sbIsTyping,
  sbClearChannel,
  sbMarkAsRead, sbGetChannelPicture,
  sbUserUnblock
} from './../../sendbirdActions'

import {getMessengerClient} from '../../utils/messenger'

export const initChatScreen = () => {
  // const sb = getMessengerClient()
  // sb.removeAllChannelHandlers();
  return {type: INIT_CHAT_SCREEN}
}

export const getChannelTitle = (channelUrl, isOpenChannel = false) => {
  return dispatch => {
    // if (isOpenChannel) {
    //   sbGetOpenChannel(channelUrl)
    //     .then((channel) => {
    //       dispatch({
    //         type: CHANNEL_TITLE_CHANGED,
    //         title: sbGetChannelTitle(channel),
    //         memberCount: channel.participantCount
    //       });
    //     })
    //     .catch((error) => { dispatch({ type: CHANNEL_TITLE_CHANGED_FAIL }) });
    // } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        dispatch({
          type: CHANNEL_TITLE_CHANGED,
          title: sbGetChannelTitle(channel),
          memberCount: channel.memberCount
        })
      })
      .catch(error => {
        dispatch({type: CHANNEL_TITLE_CHANGED_FAIL, error})
      }
      )
    // }
  }
}
export const onUserUnBlockPress = blockedUserId => {
  return dispatch => {
    sbUserUnblock(blockedUserId)
      .then(user => dispatch({type: USER_UNBLOCK_SUCCESS}))
      .catch(error => dispatch({type: USER_UNBLOCK_FAIL, error}))
  }
}

export const onUserBlockPress = blockUserId => {
  return dispatch => {
    sbUserBlock(blockUserId)
      .then(user => dispatch({type: USER_BLOCK_SUCCESS}))
      .catch(error => dispatch({type: USER_BLOCK_FAIL, error}))
  }
}

export const getChannelPicture = (channelUrl, isOpenChannel = false) => {
  return dispatch => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        dispatch({
          type: CHANNEL_PICTURE_CHANGED,
          picture: sbGetChannelPicture(channel)
        })
      })
      .catch(error => {
        dispatch({type: CHANNEL_PICTURE_CHANGED_FAIL, error})
      }
      )
  }
}

export const createChatHandler = (channelUrl, isOpenChannel = false) => {
  return dispatch => {
    // if (isOpenChannel) {
    //   sbGetOpenChannel(channelUrl)
    //     .then((channel) => {
    //       sbOpenChannelEnter(channel)
    //         .then((channel) => {
    //           registerOpenChannelHandler(channelUrl, dispatch);
    //           dispatch({ type: CREATE_CHAT_HANDLER_SUCCESS });
    //         })
    //         .catch( (error) => dispatch({ type: CREATE_CHAT_HANDLER_FAIL }) );
    //     })
    //     .catch( (error) => dispatch({ type: CREATE_CHAT_HANDLER_FAIL }) );
    // } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        registerGroupChannelHandler(channelUrl, dispatch)
        dispatch({type: CREATE_CHAT_HANDLER_SUCCESS})
      })
      .catch(error => dispatch({type: CREATE_CHAT_HANDLER_FAIL, error}))
    // }
  }
}

const registerCommonHandler = (channelHandler, channelUrl, dispatch) => {
  channelHandler.onMessageReceived = (channel, message) => {
    if (channel.url === channelUrl) {
      if (channel.isGroupChannel()) {
        sbMarkAsRead({channel})
      }
      dispatch({
        type: MESSAGE_RECEIVED,
        payload: message
      })
    }
  }
  channelHandler.onMessageUpdated = (channel, message) => {
    if (channel.url === channelUrl) {
      dispatch({
        type: MESSAGE_UPDATED,
        payload: message
      })
    }
  }
  channelHandler.onMessageDeleted = (channel, messageId) => {
    if (channel.url === channelUrl) {
      dispatch({
        type: MESSAGE_DELETED,
        payload: messageId
      })
    }
  }
}

const registerGroupChannelHandler = (channelUrl, dispatch) => {
  const sb = getMessengerClient()
  let channelHandler = new sb.ChannelHandler()

  registerCommonHandler(channelHandler, channelUrl, dispatch)

  channelHandler.onUserJoined = (channel, user) => {
    if (channel.url === channelUrl) {
      dispatch({
        type: CHANNEL_TITLE_CHANGED,
        title: sbGetChannelTitle(channel),
        memberCount: channel.memberCount
      })
    }
  }
  channelHandler.onUserLeft = (channel, user) => {
    if (channel.url === channelUrl) {
      dispatch({
        type: CHANNEL_TITLE_CHANGED,
        title: sbGetChannelTitle(channel),
        memberCount: channel.memberCount
      })
    }
  }
  channelHandler.onReadReceiptUpdated = channel => {
    if (channel.url === channelUrl) {
      dispatch({type: READ_RECEIPT_UPDATED})
    }
  }
  channelHandler.onTypingStatusUpdated = channel => {
    if (channel.url === channelUrl) {
      const typing = sbIsTyping(channel)
      if (typing !== 'otherChat') {
        dispatch({
          type: TYPING_STATUS_UPDATED,
          typing: typing
        })
      }
    }
  }

  sb.addChannelHandler(channelUrl, channelHandler)
}

export const getPrevMessageList = previousMessageListQuery => {
  return dispatch => {
    if (previousMessageListQuery.hasMore) {
      sbGetMessageList(previousMessageListQuery)
        .then(messages => {
          dispatch({
            type: MESSAGE_LIST_SUCCESS,
            list: messages
          })
        })
        .catch(error => dispatch({type: MESSAGE_LIST_FAIL, error}))
    } else {
      dispatch({type: MESSAGE_LIST_FAIL, messages: false})
    }
  }
}

export const onSendAll = (channelUrl, textMessage, files = []) => {
  return dispatch => {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        const messageTemp = sbSendTextMessage(channel, textMessage, (message, error) => {
          if (error) {
            dispatch({type: SEND_MESSAGE_FAIL})
          } else {
            dispatch({
              type: SEND_MESSAGE_SUCCESS,
              message: message
            })

            files.map(file => {
              const messageTemp = sbSendFileMessage(channel, file.file, (message, error) => {
                if (error) {
                  dispatch({type: SEND_MESSAGE_FAIL})
                  return
                }
                dispatch({
                  type: SEND_MESSAGE_SUCCESS,
                  message: message
                })
              })

              dispatch({
                type: SEND_MESSAGE_TEMPORARY,
                message: messageTemp
              })
              return false
            })
          }
        })
        dispatch({
          type: SEND_MESSAGE_TEMPORARY,
          message: messageTemp
        })
      })
      .catch(error => dispatch({type: SEND_MESSAGE_FAIL, error}))
  }
}

export const onSendButtonPress = (channelUrl, isOpenChannel = false, textMessage) => {
  return dispatch => {
    // if (isOpenChannel) {
    //   sbGetOpenChannel(channelUrl)
    //     .then((channel) => {
    //       sendTextMessage(dispatch, channel, textMessage);
    //     })
    //     .catch( (error) => dispatch({ type: SEND_MESSAGE_FAIL }) )
    // } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        sendTextMessage(dispatch, channel, textMessage)
      })
      .catch(error => dispatch({type: SEND_MESSAGE_FAIL, error}))
  }
  // }
}

const sendTextMessage = (dispatch, channel, textMessage) => {
  const messageTemp = sbSendTextMessage(channel, textMessage, (message, error) => {
    if (error) {
      dispatch({type: SEND_MESSAGE_FAIL})
    } else {
      dispatch({
        type: SEND_MESSAGE_SUCCESS,
        message: message
      })
    }
  })
  dispatch({
    type: SEND_MESSAGE_TEMPORARY,
    message: messageTemp
  })
}

export const onFileButtonPress = (channelUrl, isOpenChannel = false, source) => {
  return dispatch => {
    // if (isOpenChannel) {
    //   sbGetOpenChannel(channelUrl)
    //     .then((channel) => {
    //       sendFileMessage(dispatch, channel, source);
    //     })
    //     .catch((error) => dispatch({ type: SEND_MESSAGE_FAIL }))
    // } else {
    sbGetGroupChannel(channelUrl)
      .then(channel => {
        sendFileMessage(dispatch, channel, source)
      })
      .catch(error => dispatch({type: SEND_MESSAGE_FAIL, error}))
  }
  // }
}

const sendFileMessage = (dispatch, channel, file) => {
  const messageTemp = sbSendFileMessage(channel, file,
    (message, error) => {
      if (message.type === 'progress') {
        dispatch({
          type: MESSAGE_FILE_PROGRESS,
          message: message,
          reqId: messageTemp.reqId
        })
        return
      }

      if (error) {
        dispatch({type: SEND_MESSAGE_FAIL})
        return
      }
      dispatch({
        type: SEND_MESSAGE_SUCCESS,
        message: message
      })
    })
  dispatch({
    type: SEND_MESSAGE_TEMPORARY,
    message: messageTemp
  })
}

export const onClearChannel = channelUrl => {
  return dispatch => {
    sbClearChannel(channelUrl)
      .then(response => dispatch({type: CLEAR_CHANNEL_SUCCESS}))
      .catch(error => dispatch({type: CLEAR_CHANNEL_FAIL, error}))
  }
}

export const typingStart = channelUrl => {
  return dispatch => {
    sbTypingStart(channelUrl)
      .then(response => dispatch({type: SEND_TYPING_START_SUCCESS}))
      .catch(error => dispatch({type: SEND_TYPING_START_FAIL, error}))
  }
}

export const typingEnd = channelUrl => {
  return dispatch => {
    sbTypingEnd(channelUrl)
      .then(response => dispatch({type: SEND_TYPING_END_SUCCESS}))
      .catch(error => dispatch({type: SEND_TYPING_END_FAIL, error}))
  }
}
